import request from '@/utils/request'

export function create (data) {
  return request({
    url: '/api/v1/hourcheck/create',
    method: 'post',
    data
  })
}

export function delhourcheck (id) {
  return request({
    url: '/api/v1/hourcheck/delete',
    method: 'post',
    data: { id }
  })
}

export function update (data) {
  return request({
    url: '/api/v1/hourcheck/update',
    method: 'post',
    data
  })
}

export function gethourcheckbyid (id) {
  return request({
    url: '/api/v1/hourcheck/get',
    method: 'get',
    params: { id }
  })
}

export function querypage (data) {
  return request({
    url: '/api/v1/hourcheck/querypage',
    method: 'post',
    data
  })
}